import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const BLUsers = lazyLoad(
    () => import('./index'),
    module => module.BLUsers,
    { fallback: <LoadingSpinner /> },
);
